import { privateRequest, type ApiResponse } from "../axios";

const ENDPOINTS = {
    LOCATION_COVERAGE_REPORT_DETAILS: "api/GetDistanceCoverage",
    LOCATOIN_COVERAGE_REPORT_EXPORT: "api/ExportDistanceCoverage"
}

export const getLocationCoverageDetails = async (payload: any): Promise<ApiResponse<any[]>> => {
    const response = await privateRequest.get<ApiResponse<any[]>>(ENDPOINTS.LOCATION_COVERAGE_REPORT_DETAILS, { params: payload });
    return response.data;
};

export const getLocationDistanceCoverageExport = async (payload: any) => {
    const response = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.LOCATOIN_COVERAGE_REPORT_EXPORT, payload, { responseType: "arraybuffer" });
    return response;
};

const LocationCoverageReport = {
    getLocationCoverageDetails,
    getLocationDistanceCoverageExport
}

export default LocationCoverageReport;
